import styled from 'styled-components';

import { SettingsSubtitle } from 'settings/components/SettingsSubtitle';

const Underlined = styled.span`
  border-bottom: 1px solid currentColor;
  display: inline-block;
  line-height: 0.95;
`;

export function SettingsRewardsSubtitle({
  className,
}: SettingsRewardsSubtitleProps) {
  return (
    <SettingsSubtitle className={className}>
      Select Areas of Excellence <Underlined>or</Underlined> Rewards to keep
      your team engaged and motivated to deliver their best performance during
      every customer interaction
    </SettingsSubtitle>
  );
}

interface SettingsRewardsSubtitleProps {
  className?: string;
}
